<template>
  <article>
    <el-row><p></p></el-row>
    <el-row>
      <el-col>
        <h4 style="margin-left: 15px; font-size: 14px">
          {{ this.$t("pages.wording.carPlat") }}
          <el-tag style="font-size: 14px" effect="plain">
            {{
              this.reserveCarPlat !== null && this.reserveCarPlat !== ""
                ? this.reserveCarPlat
                : this.$t("pages.wording.vendorNotYetEdit")
            }}
          </el-tag>
        </h4>
      </el-col>
    </el-row>
    <el-table
      class="reserveLogTable"
      :data="reserveSOList"
      :span-method="tableSpanMethod"
      border
      height="400px"
      :header-row-style="{ textAlign: 'center' }"
    >
      <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="150">
        <template slot-scope="scope">
          <article v-if="(scope.row.releaseOrderNo || '').toUpperCase() === 'TOTAL'">
            {{ scope.row.releaseOrderNo }}
          </article>
          <el-link v-else @click="openReleasePage(scope.row.releaseID)">
            {{ scope.row.releaseOrderNo }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="SO" label="SO" width="100"></el-table-column>
      <el-table-column prop="SOLine" label="SO LINE" width="100"></el-table-column>
      <el-table-column prop="partNo" :label="$t('pages.wording.partNo')" width="120"></el-table-column>
      <el-table-column :label="$t('pages.wording.partName')" width="120">
        <template slot-scope="scope">
          {{ displayPartName(getLanguage(), scope.row.partNameCN, scope.row.partName) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('pages.wording.netWeight')" width="120">
        <template slot-scope="scope">
          {{
            scope.row.netWeight === parseInt(scope.row.netWeight)
              ? scope.row.netWeight
              : scope.row.netWeight.toFixed($global.defaultPointNumForRelease)
          }}
        </template>
      </el-table-column>
      <el-table-column prop="packType" :label="$t('pages.wording.packType')" width="120">
        <template slot-scope="scope">
          {{ $store.getters.getSysCodeText("packType", scope.row.packType) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('pages.wording.packWeight')" width="120">
        <template slot-scope="scope">
          {{
            scope.row.packWeight === parseInt(scope.row.packWeight)
              ? scope.row.packWeight
              : scope.row.packWeight.toFixed($global.defaultPointNumForRelease)
          }}
        </template>
      </el-table-column>
      <el-table-column prop="grossWeight" :label="$t('pages.wording.grossWeight')" width="120">
        <template slot-scope="scope">
          {{
            scope.row.grossWeight === parseInt(scope.row.grossWeight)
              ? scope.row.grossWeight
              : scope.row.grossWeight.toFixed($global.defaultPointNumForRelease)
          }}
        </template>
      </el-table-column>
      <el-table-column prop="unit" :label="$t('pages.wording.unit')" width="120"></el-table-column>
      <el-table-column prop="plantCode" label="Plant Code"></el-table-column>
    </el-table>
  </article>
</template>

<script>
import { utils } from "@/utils/utils.js"
import { api } from "@/utils/api.js"
import { mapGetters } from "vuex"

export default {
  name: "ReserveSOTable",
  props: {
    reserveID: {
      type: Number,
      default: () => -1,
    },
    reserveCarPlat: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      reserveSOList: [],
    }
  },
  created() {
    this.getSOTableList()
  },
  methods: {
    ...mapGetters(["getLanguage"]),
    getSOTableList() {
      api
        .apiGetSOTableBindingWithReserve(this.reserveID)
        .then((res) => {
          if (res) {
            this.reserveSOList = res.data
          } else {
            this.reserveSOList = []
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    displayPartName(lang, chName, enName) {
      return utils.displayPartName(utils.displayCHName(lang), chName, enName)
    },
    openReleasePage(releaseID) {
      let data = {
        id: releaseID,
        routeName: "PageMyReleaseOrder",
      }
      let routeData = this.$router.resolve({
        name: "PageMyReleaseOrderForm",
        query: data,
      })
      window.open(routeData.href, "_blank")
    },
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0 || row.releaseOrderNo !== this.reserveSOList[rowIndex - 1].releaseOrderNo) {
          return {
            rowspan: row.SoCount,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
  },
  computed: {},
}
</script>

<style scoped>
.reserveLogTable a:hover {
  color: #007bff !important;
}
.reserveLogTable a {
  color: #007bff !important;
}
.reserveLogTable th {
  border-top: 1px solid #ebeef5 !important;
}
</style>
